/*
 * Copyright © 2017, Rezo Zero
 *
 * @file TransitionFactory.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import FadeTransition from '../transitions/FadeTransition'

export default class TransitionFactory {
    getTransition (previousState, state) {
        let transition = null

        switch (state.transitionName) {
        case 'fade':
            transition = new FadeTransition()
            break
        default:
            transition = new FadeTransition()
            break
        }

        return transition
    }
}



// WEBPACK FOOTER //
// ./webpack/js/factories/TransitionFactory.js